import React from 'react';
import { YStack, XStack, Image, SizableText, H4, Card } from 'tamagui';
import type { UIComponentContract } from '../../types/componentContract';

export const uiContract: UIComponentContract = {
  id: "profile.card",
  accepts: {
    capability: "read_profile",
    shape: {
      id: "string",
      name: "string",
      image: "string?",
      email: "string?",
      title: "string?",
      bio: "string?"
    },
    required: ["id", "name"],
    optional: ["image", "email", "title", "bio"]
  },
  renders: "card",
  priority: 10,
  surface: "options"
};

interface ProfileCardProps {
  data: {
    id: string;
    name: string;
    image?: string;
    email?: string;
    title?: string;
    bio?: string;
  };
}

export const ProfileCard: React.FC<ProfileCardProps> = (props) => {
  const { data } = props || {};

  if (!data) {
    return (
      <Card borderRadius={16} padding="$5" elevate backgroundColor="$background">
        <SizableText>No profile data available</SizableText>
      </Card>
    );
  }

  return (
    <Card
      borderRadius={16}
      padding="$5"
      elevate
      backgroundColor="$background"
    >
      <XStack alignItems="center" gap="$4">
        {data?.image ? (
          <Image
            source={{ uri: data?.image }}
            width={70}
            height={70}
            borderRadius={35}
          />
        ) : (
          <XStack
            width={70}
            height={70}
            borderRadius={35}
            backgroundColor="$blue5"
            alignItems="center"
            justifyContent="center"
          >
            <SizableText color="white" fontSize="$9" fontWeight="bold">
              {data?.name?.charAt(0).toUpperCase()}
            </SizableText>
          </XStack>
        )}

        <YStack flex={1} gap="$2">
          <H4 fontWeight="700">{data?.name}</H4>
          {data?.title && (
            <SizableText size="$4" color="$gray10">
              {data?.title}
            </SizableText>
          )}
          {data?.email && (
            <SizableText size="$3" color="$gray9">
              {data?.email}
            </SizableText>
          )}
          {data?.bio && (
            <SizableText size="$3" color="$gray10" numberOfLines={2}>
              {data?.bio}
            </SizableText>
          )}
        </YStack>
      </XStack>
    </Card>
  );
};

// Attach contract to component
(ProfileCard as any).uiContract = uiContract;

export default ProfileCard;

